"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Logger {
    constructor() {
        this.colorReset = "\x1b[0m";
        this.colorRed = "\x1b[31m";
        this.colorGreen = "\x1b[32m";
        this.colorYellow = "\x1b[33m";
        this.colorBlue = "\x1b[34m";
        this.colorMagenta = "\x1b[35m";
        this.colorCyan = "\x1b[36m";
        this.colorWhite = "\x1b[37m";
    }
    logWithColor(color, label, message) {
        console.log(`${color}[WZ]${label} - ${message}${this.colorReset}`);
    }
    logInfo(message) {
        this.logWithColor(this.colorBlue, "[WZ][INFO]", message);
    }
    logError(message, metadata) {
        console.error(`${this.colorRed}[WZ][ERROR] - ${message}${this.colorReset}`, metadata);
    }
    logDebug(message) {
        this.logWithColor(this.colorGreen, "[WZ][DEBUG]", message);
    }
    logWarning(message) {
        this.logWithColor(this.colorYellow, "[WZ][WARNING]", message);
    }
}
exports.default = new Logger();
//# sourceMappingURL=Logger.js.map